import { API as MOCK_AMPLIFY_API } from '../__mocks__/aws-amplify';
import { API as AMPLIFY_API } from 'aws-amplify';
import { linkParticipantSampleMutation } from '../graphql/mutations';
import { getParticipantDetailsQuery } from '../graphql/queries';
import { GetParticipantResponse, LinkParticipantSampleResponse } from '../types/common.types';

const API = process.env.REACT_APP_USE_MOCKS === 'true' ? MOCK_AMPLIFY_API : AMPLIFY_API;

const portalApi = {
  getParticipant: async (id: string): Promise<any> => {
    try {
      return (await API.graphql({
        query: getParticipantDetailsQuery,
        variables: {
          participantId: id,
        },
      })) as GetParticipantResponse;
    } catch (error) {
      return error as GetParticipantResponse;
    }
  },
  linkParticipantSample: async (values: { participantId: string; sampleBarcode: string }): Promise<any> => {
    try {
      return (await API.graphql({
        query: linkParticipantSampleMutation,
        variables: {
          participantId: values.participantId,
          sampleBarcode: values.sampleBarcode,
        },
      })) as LinkParticipantSampleResponse;
    } catch (error) {
      return error as LinkParticipantSampleResponse;
    }
  },
};

export default portalApi;
